export default __webpack_public_path__ + "static/media/free-sessions-icon.ab6115e8.svg";